import React, { useState } from 'react';
import { motion } from 'framer-motion';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-inner">
        <a href="#home" className="logo-link">
          <motion.img
            src={`${process.env.PUBLIC_URL}/logo.svg`}
            alt="Wetware"
            className="header-logo"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          />
        </a>

        <nav className="nav-desktop">
          <ul className="nav-list">
            <li>
              <a href="#home" className="nav-link">[HOME]</a>
            </li>
            <li>
              <a href="#services" className="nav-link">[SERVICES]</a>
            </li>
            <li>
              <a href="mailto:admin@wetware.ai" className="nav-link">[CONTACT]</a>
            </li>
          </ul>
        </nav>

        <button
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className="menu-text">{isMenuOpen ? '[CLOSE]' : '[MENU]'}</span>
        </button>

        {isMenuOpen && (
          <motion.nav
            className="nav-mobile"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2 }}
          >
            <ul className="nav-list-mobile">
              <li>
                <a
                  href="#home"
                  className="nav-link-mobile"
                  onClick={() => setIsMenuOpen(false)}
                >
                  HOME
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="nav-link-mobile"
                  onClick={() => setIsMenuOpen(false)}
                >
                  SERVICES
                </a>
              </li>
              <li>
                <a
                  href="mailto:admin@wetware.ai"
                  className="nav-link-mobile"
                  onClick={() => setIsMenuOpen(false)}
                >
                  CONTACT
                </a>
              </li>
            </ul>
          </motion.nav>
        )}
      </div>
    </header>
  );
};

export default Header;
